// extracted by mini-css-extract-plugin
export default {"container":"styles_container__jkfT8","content":"styles_content__W+AzR"};